import * as React from 'react';

import { cn } from '@/lib/utils';

/**
 * Light-themed scrollbars for surfaces on white/light-gray backgrounds.
 * Use `as="main"` | `as="nav"` when you need semantic HTML (refs forwarded).
 */
export const ScrollArea = React.forwardRef(({ as: Comp = 'div', className, ...props }, ref) => (
  <Comp ref={ref} data-slot="scroll-area" className={cn('scrollbar-light min-h-0', className)} {...props} />
));
ScrollArea.displayName = 'ScrollArea';
